import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ds-table__cell-content ds-table__cell-content--ordered"
}

import DsIcon from "../icon/ds-icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-table-cell',
  props: {
    type: { default: "td" },
    enableOrdering: { type: Boolean, default: false },
    isOrderingActive: { type: Boolean, default: false },
    isOrderDesc: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), {
    class: _normalizeClass(["ds-table__cell", {
            'ds-table__cell--th': _ctx.type === 'th',
            'ds-table__cell--ordered': _ctx.enableOrdering,
            'ds-table__cell--active': _ctx.isOrderingActive,
            'ds-table__cell--desc': _ctx.isOrderDesc,
        }]),
    scope: _ctx.type === 'th' ? 'col' : null
  }, {
    default: _withCtx(() => [
      (_ctx.enableOrdering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default"),
            _createVNode(DsIcon, { name: "chevron-up" })
          ]))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["class", "scope"]))
}
}

})